import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state:{
    menuKey:'1',
    controlEventBus:'',
    advertiser:'',
  },
  mutations: {
    // 控制导航位置显示
    setMenuKey(state,menuKey) {
      state.menuKey = menuKey;
    },
    // 控制event/resource
    setControlEventBus(state,controlEventBus){
      state.controlEventBus = controlEventBus;
    },
    // 控制ADVERTISERS
    setAdvertiser(state,advertiser){
      state.advertiser = advertiser;
    }
  },
})
export default store;